export default __webpack_public_path__ + "1cd9858bf0b4c91257aaf6b571dcc69f.svg";